export default [
  {
    path: '/list-appeal',
    name: 'list-appeal',
    component: () => import('@/views/modules/ListAppeal'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_appeal',
          active: true,
        },
      ],
    },
  },
]
